import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "order-details" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "value title-bg" }
const _hoisted_6 = { class: "value title-bg ml-2" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "section" }
const _hoisted_10 = { class: "section-title" }
const _hoisted_11 = {
  key: 0,
  class: "mobile-payment"
}
const _hoisted_12 = { class: "payment-amount" }
const _hoisted_13 = { class: "original-price" }
const _hoisted_14 = { class: "discount-tip" }
const _hoisted_15 = {
  key: 1,
  class: "discount-info"
}
const _hoisted_16 = { class: "payment-buttons" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "qr-code-container" }
const _hoisted_19 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "payment-info" }
const _hoisted_22 = { class: "amount" }
const _hoisted_23 = { class: "original-price" }
const _hoisted_24 = { class: "discount-tip-pc" }
const _hoisted_25 = {
  key: 1,
  class: "discount-info"
}
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "qr-code-container" }
const _hoisted_28 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_29 = ["srcdoc"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "payment-info" }
const _hoisted_32 = { class: "amount" }
const _hoisted_33 = { class: "original-price" }
const _hoisted_34 = { class: "discount-tip-pc" }
const _hoisted_35 = {
  key: 1,
  class: "discount-info"
}
const _hoisted_36 = { class: "activation-code-container" }
const _hoisted_37 = { class: "activation-input-wrapper" }
const _hoisted_38 = { class: "section preview-section" }
const _hoisted_39 = { class: "section-title" }
const _hoisted_40 = { class: "paper-preview-box" }
const _hoisted_41 = { class: "preview-item" }
const _hoisted_42 = { class: "preview-page" }
const _hoisted_43 = { class: "page-scaler" }
const _hoisted_44 = { class: "preview-item" }
const _hoisted_45 = { class: "preview-page" }
const _hoisted_46 = { class: "page-scaler" }
const _hoisted_47 = { class: "mobile-activation-content" }
const _hoisted_48 = { class: "activation-input-section" }
const _hoisted_49 = { class: "activation-buttons" }

import { ref, toRefs, onMounted, watch, onUnmounted, computed } from 'vue';
import { ArrowRight, Document, Loading, Ticket, View, Wallet } from '@element-plus/icons-vue'
import { get, post, getBaseURL, getUserDiscountByPay, useActivationCode } from '@/api/api';
import { ElMessage } from 'element-plus';
import QRCode from 'qrcode';
import { SourceTracker } from '@/utils/sourceTracker';
import CoverPage from '@/view/CoverPage.vue';
import TableOfContentsPage from '@/view/TableOfContentsPage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmOrder',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  order: {
    type: Object,
    required: true,
  },
  isLoggedIn: {
    type: Boolean,
    default: false,
  },
  onShowLogin: {
    type: Function,
    default: () => {},
  },
},
  emits: ['update:visible', 'payment-success', 'show-benefits'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { visible } = toRefs(props);
const activePayment = ref('wechat');
// const promoCode = ref('');
const price = ref(''); // 默认价格
const originalPrice = ref(''); // 原价
const wechatQrCode = ref('@/assets/logo.png'); // 微信支付二维码URL
const alipayQrCode = ref('@/assets/logo.png'); // 支付宝二维码URL
const alipayHtml = ref(''); // 支付宝HTML内容
const isLoadingQrCode = ref(false); // 二维码加载状态
const isLoadingPayment = ref(false); // 移动端支付按钮加载状态
const orderNumber = ref(''); // 从支付接口返回的订单编号
const pollTimer = ref<ReturnType<typeof setInterval> | null>(null); // 轮询定时器
const userDiscountInfo = ref<any>(null); // 用户折扣信息
const activationCode = ref(''); // 激活码内容
const isLoadingActivation = ref(false); // 激活码支付加载状态

// 移动端激活码相关
const showMobileActivationDialog = ref(false); // 移动端激活码弹窗显示状态
const mobileActivationCode = ref(''); // 移动端激活码内容

// 检测是否为移动设备
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

// 获取用户折扣信息
const fetchUserDiscount = async () => {
  if (!props.isLoggedIn) {
    userDiscountInfo.value = null;
    return;
  }

  try {
    const response = await getUserDiscountByPay();
    if (response.data && response.data.code === 0) {
      userDiscountInfo.value = response.data;
    } else {
      userDiscountInfo.value = null;
    }
  } catch (error) {
    console.error('获取用户折扣信息失败:', error);
    userDiscountInfo.value = null;
  }
};

// 生成折扣文案
const generateDiscountText = (discountInfo: any) => {
  if (!discountInfo) return '';

  const { current, next, remaining } = discountInfo;

  let text = '';

  // 前半段文案
  if (current) {
    text += `当前享受${current}，`;
  } else {
    text += '目前未达到折扣条件，';
  }

  // 后半段文案
  if (!remaining) {
    text += '您已达到最高优惠等级';
  } else {
    text += `再支付${remaining}笔订单则可享受${next}`;
  }

  return text;
};

// 处理登录点击
const handleLoginClick = () => {
  if (props.onShowLogin) {
    props.onShowLogin();
  }
};

// 打开权益信息；未登录时先引导用户登录
const handleBenefitsClick = () => {
  if (!props.isLoggedIn) {
    handleLoginClick();
    return;
  }

  emit('show-benefits');
};

// 获取价格
const getPrice = async () => {
  try {
    const wordCount = props.order.wordNumber || 6000;
    const response = await get('/aiGenerate/getPrice', {
      wordCount: wordCount
    });
    if (response.data && response.data.data) {
      if (response.data.data.discountsPrice) {
        price.value = response.data.data.discountsPrice;
      }
      if (response.data.data.price) {
        originalPrice.value = response.data.data.price;
      }
    }
  } catch (error) {
    console.error('获取价格失败:', error);
  }
};

// 生成订单
const generateOrder = async () => {
  try {
    // 先获取价格
    await getPrice();
    
    const requestData = {
      payType: 1,
      count: 1,
      businessData: buildBusinessData(),
      sourceUrl: SourceTracker.getSourceUrlForOrder()
    };
    
    const response = await post('/aiGenerate/generateOrder', requestData);
    
    if (response.data && response.data.data) {
      orderNumber.value = response.data.data;
      console.log('订单生成成功，订单号:', orderNumber.value);
      console.log('来源URL:', SourceTracker.getSourceUrl());
    }
  } catch (error) {
    console.error('生成订单失败:', error);
    ElMessage.error('生成订单失败，请重试');
  }
};

// 构建businessData参数
const buildBusinessData = () => {
  // 从fiveStep组件获取catalogs数据
  const catalogs = props.order.catalogs || [];
  
  // 处理catalogs数据结构：去掉id字段，将label换成title
  const processedCatalogs = catalogs.map((item: any) => ({
    title: item.label || item.title || '',
    children: item.children ? item.children.map((child: any) => ({
      title: child.label || child.title || '',
      children: child.children ? child.children.map((grandChild: any) => ({
        title: grandChild.label || grandChild.title || ''
      })) : []
    })) : []
  }));
  
  const businessData = {
    content: props.order.content || '',
    keywords: props.order.keywords ? props.order.keywords.join(',') : '',
    literature: props.order.literature ? JSON.stringify(props.order.literature) : '',
    digest: props.order.abstract || '',
    wordCount: props.order.wordNumber || 6000,
    title: props.order.title || '',
    type: 0, // 论文类型
    pageNum: 1, // 默认页码
    catalogs: processedCatalogs,
    sourceUrl: SourceTracker.getSourceUrlForOrder()
  };
  
  return JSON.stringify(businessData);
};

// 检测是否为微信浏览器
const isWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};

// 移动端支付处理
const handleMobilePayment = async (paymentType: 'alipay' | 'wechat') => {
  try {
    isLoadingPayment.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 根据支付类型选择不同的GET接口，直接跳转
    let apiEndpoint = '';
    
    if (paymentType === 'alipay') {
      apiEndpoint = '/aliPayMobile/pay';
    } else if (paymentType === 'wechat') {
      // 检查是否为微信浏览器
      if (isWechatBrowser()) {
        apiEndpoint = '/wxPayMobile/wxPayZb';
        
        // 为微信支付创建回调URL
        const baseURL = getBaseURL();
        const callbackUrl = `${window.location.origin}/wechat-callback?orderNumber=${orderNumber.value}`;
        const paymentUrl = `${baseURL}${apiEndpoint}?redirectUri=${encodeURIComponent(callbackUrl)}`;
        
        // 直接跳转到微信支付页面
        window.open(paymentUrl, '_blank');
        return;
      } else {
        apiEndpoint = '/wxPayMobile/pay';
      }
    }
    
    const baseURL = getBaseURL();
    const paymentUrl = `${baseURL}${apiEndpoint}?orderNumber=${orderNumber.value}`;
    
    // 在新窗口打开支付接口地址
    window.open(paymentUrl, '_blank');
    
    // 启动轮询检查支付状态
    startPolling();
    
  } catch (error) {
    console.error(`移动端${paymentType === 'alipay' ? '支付宝' : '微信'}支付失败:`, error);
    ElMessage.error('支付请求失败，请重试');
  } finally {
    isLoadingPayment.value = false;
  }
};

// 处理激活码支付
const handleActivationCodePayment = async () => {
  if (!activationCode.value.trim()) {
    ElMessage.warning('请输入激活码');
    return;
  }

  if (!orderNumber.value) {
    ElMessage.error('订单号不存在，请重新生成订单');
    return;
  }

  try {
    isLoadingActivation.value = true;

    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    formData.append('activationCode', activationCode.value.trim());

    const response = await useActivationCode(formData);

    if (response.data && response.data.code === 0) {
      // 激活码使用成功
      ElMessage.success('激活码使用成功，支付完成！');

      // 触发支付成功逻辑
      emit('update:visible', false);
      emit('payment-success', orderNumber.value);

      // 清空激活码输入
      activationCode.value = '';
    } else {
      // 激活码使用失败，显示错误信息
      const errorMsg = response.data?.msg || '激活码使用失败，请检查激活码是否正确';
      ElMessage.error(errorMsg);
    }
  } catch (error) {
    console.error('激活码支付失败:', error);
    ElMessage.error('激活码使用失败，请重试');
  } finally {
    isLoadingActivation.value = false;
  }
};

// 处理移动端激活码支付
const handleMobileActivationPayment = async () => {
  if (!mobileActivationCode.value.trim()) {
    ElMessage.warning('请输入激活码');
    return;
  }

  if (!orderNumber.value) {
    ElMessage.error('订单号不存在，请重新生成订单');
    return;
  }

  try {
    isLoadingActivation.value = true;

    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    formData.append('activationCode', mobileActivationCode.value.trim());

    const response = await useActivationCode(formData);

    if (response.data && response.data.code === 0) {
      // 激活码使用成功
      ElMessage.success('激活码使用成功，支付完成！');

      // 关闭移动端激活码弹窗
      showMobileActivationDialog.value = false;

      // 触发支付成功逻辑
      emit('update:visible', false);
      emit('payment-success', orderNumber.value);

      // 清空激活码输入
      mobileActivationCode.value = '';
      activationCode.value = '';
    } else {
      // 激活码使用失败，显示错误信息
      const errorMsg = response.data?.msg || '激活码使用失败，请检查激活码是否正确';
      ElMessage.error(errorMsg);
    }
  } catch (error) {
    console.error('移动端激活码支付失败:', error);
    ElMessage.error('激活码使用失败，请重试');
  } finally {
    isLoadingActivation.value = false;
  }
};

// 生成二维码的辅助函数
const generateQRCode = async (text: string): Promise<string> => {
  try {
    const qrCodeDataUrl = await QRCode.toDataURL(text, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
    return qrCodeDataUrl;
  } catch (error) {
    console.error('生成二维码失败:', error);
    throw error;
  }
};

// 获取微信支付二维码
const getWechatPayQrCode = async () => {
  try {
    isLoadingQrCode.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    
    const response = await post('/wxPay/pay', formData);
    
    if (response.data && response.data.data) {
      // 解析返回的数据
      const responseData = response.data.data;
      
      let paymentUrl = '';
      
      // 如果返回的是字符串，说明是支付URL
      if (typeof responseData === 'string') {
        paymentUrl = responseData;
      } else if (typeof responseData === 'object') {
        paymentUrl = responseData.payUrl || responseData.url || responseData.data;
      }
      
      // 使用本地qrcode库生成二维码
      if (paymentUrl) {
        const qrCodeDataUrl = await generateQRCode(paymentUrl);
        wechatQrCode.value = qrCodeDataUrl;
      }
    }
    
    // 启动轮询检查支付状态
    startPolling();
  } catch (error) {
    console.error('获取微信支付二维码失败:', error);
    ElMessage.error('获取支付二维码失败，请重试');
  } finally {
    isLoadingQrCode.value = false;
  }
};

// 获取支付宝二维码
const getAlipayQrCode = async () => {
  try {
    isLoadingQrCode.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    
    const response = await post('/aliPay/pay', formData);
    
    if (response.data && response.data.data) {
      // 解析返回的数据
      const responseData = response.data.data;
      
      // 如果返回的是字符串，说明是HTML页面代码
      if (typeof responseData === 'string') {
        alipayHtml.value = responseData;
      } else if (typeof responseData === 'object') {
        const htmlContent = responseData.html || responseData.data;
        if (htmlContent) {
          alipayHtml.value = htmlContent;
        }
        
        // 如果同时有支付URL，也生成二维码
        const paymentUrl = responseData.payUrl || responseData.url;
        if (paymentUrl) {
          const qrCodeDataUrl = await generateQRCode(paymentUrl);
          alipayQrCode.value = qrCodeDataUrl;
        }
      }
    }
    
    // 启动轮询检查支付状态
    startPolling();
  } catch (error) {
    console.error('获取支付宝二维码失败:', error);
    ElMessage.error('获取支付二维码失败，请重试');
  } finally {
    isLoadingQrCode.value = false;
  }
};

// 检查订单支付状态
const checkOrderStatus = async () => {
  if (!orderNumber.value) {
    return;
  }
  
  try {
    const response = await get('/aiGenerate/getOrderStatus', {
      orderNumber: orderNumber.value
    });
    
    if (response.data && response.data.data === 1) {
      // 支付成功
      ElMessage.success('支付成功，请通过订单号查询生成进度！');
      stopPolling();
      emit('update:visible', false);
      // 触发支付成功事件，让父组件显示订单下载弹窗
      emit('payment-success', orderNumber.value);
    }
  } catch (error) {
    console.error('检查订单状态失败:', error);
  }
};

// 开始轮询
const startPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
  }
  
  pollTimer.value = setInterval(() => {
    checkOrderStatus();
  }, 3000); // 每3秒检查一次
};

// 停止轮询
const stopPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
};

// 监听支付方式变化
watch(activePayment, (newPayment) => {
  // 切换支付方式时停止之前的轮询
  stopPolling();

  if (newPayment === 'wechat') {
    alipayHtml.value = ''; // 重置支付宝HTML内容
    getWechatPayQrCode();
  } else if (newPayment === 'alipay') {
    getAlipayQrCode();
  } else if (newPayment === 'activationCode') {
    // 激活码支付不需要生成二维码
    alipayHtml.value = ''; // 重置支付宝HTML内容
  }
});

// 监听登录状态变化
watch(() => props.isLoggedIn, async (newValue, oldValue) => {
  // 当用户从未登录变为已登录时，且弹窗是打开状态
  if (newValue && !oldValue && visible.value) {
    // 停止当前轮询
    stopPolling();
    
    // 重新获取用户折扣信息
    await fetchUserDiscount();
    
    // 重新生成订单（包括获取价格）
    await generateOrder();
    
    // PC端重新获取支付二维码
    if (!isMobile.value) {
      if (activePayment.value === 'wechat') {
        await getWechatPayQrCode();
      } else if (activePayment.value === 'alipay') {
        await getAlipayQrCode();
      }
    }
    
    ElMessage.success('登录成功，订单已更新');
  }
});

// 监听弹窗显示状态
watch(visible, async (newVisible) => {
  if (newVisible) {
    // 弹窗打开时先获取用户折扣信息
    await fetchUserDiscount();
    
    // 然后生成订单
    await generateOrder();
    
    // PC端默认调用微信支付接口
    if (!isMobile.value) {
      getWechatPayQrCode();
    }
  } else {
    // 弹窗关闭时重置HTML内容和停止轮询
    alipayHtml.value = '';
    stopPolling();
  }
});

// 组件挂载时不需要自动获取价格，等弹窗打开时生成订单
onMounted(() => {
  // 组件挂载时不执行任何操作，等待弹窗打开时生成订单
});

// 组件卸载时停止轮询
onUnmounted(() => {
  stopPolling();
});


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": _unref(visible),
      title: "确定订单",
      width: isMobile.value ? '90%' : '650px',
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (emit('update:visible', $event))),
      "show-close": true,
      center: "",
      class: "mobile-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Document))
                ]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ml-1" }, "核对订单:", -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "论文标题:", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.order.title), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.order.wordNumber) + "字", 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "detail-item" }, [
              _createElementVNode("span", { class: "label" }, "生成内容:"),
              _createElementVNode("span", { class: "value" }, "封面 | 摘要 | 目录 | 正文 | 致谢 | 参考文献 高度原创")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "订单编号:", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(orderNumber.value || '加载中...'), 1)
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "detail-item" }, [
              _createElementVNode("span", { class: "label" }, "免费服务:"),
              _createElementVNode("span", { class: "value" }, "一般查重率在18%左右，官方查重超过25%可以全额退费或重新生成。")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Wallet))
                ]),
                _: 1
              }),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ml-1" }, "订单支付:", -1))
            ]),
            (isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(" 特惠价: ¥" + _toDisplayString(price.value) + " ", 1),
                    _createElementVNode("del", _hoisted_13, "原价: ¥" + _toDisplayString(originalPrice.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (!__props.isLoggedIn)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "login-tip",
                          onClick: handleLoginClick
                        }, " 登录后支付可享受累计折扣优惠 → "))
                      : (userDiscountInfo.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[15] || (_cache[15] = _createTextVNode(" 🎉 ")),
                            _createElementVNode("strong", null, _toDisplayString(generateDiscountText(userDiscountInfo.value)), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "benefits-link",
                    onClick: handleBenefitsClick
                  }, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Ticket))
                      ]),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "点击查看更多折扣信息", -1)),
                    _createVNode(_component_el_icon, { class: "benefits-link-arrow" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowRight))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large",
                      class: "payment-btn alipay-btn",
                      loading: isLoadingPayment.value,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleMobilePayment('alipay')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Wallet))
                          ]),
                          _: 1
                        }),
                        _cache[17] || (_cache[17] = _createTextVNode(" 支付宝支付 "))
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "large",
                      class: "payment-btn wechat-btn",
                      loading: isLoadingPayment.value,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleMobilePayment('wechat')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Wallet))
                          ]),
                          _: 1
                        }),
                        _cache[18] || (_cache[18] = _createTextVNode(" 微信支付 "))
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "warning",
                      size: "large",
                      class: "payment-btn activation-btn-mobile",
                      loading: isLoadingActivation.value,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showMobileActivationDialog.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Wallet))
                          ]),
                          _: 1
                        }),
                        _cache[19] || (_cache[19] = _createTextVNode(" 激活码支付 "))
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "payment-tips" }, [
                    _createElementVNode("div", { class: "tip-item" }, "如遇支付问题, 请联系客服微信"),
                    _createElementVNode("div", { class: "tip-item" }, "付款成功前请不要关闭此窗口。")
                  ], -1))
                ]))
              : (_openBlock(), _createBlock(_component_el_tabs, {
                  key: 1,
                  modelValue: activePayment.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activePayment).value = $event)),
                  class: "demo-tabs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "微信支付",
                      name: "wechat"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            (isLoadingQrCode.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_el_icon, { class: "loading-icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Loading))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "loading-text" }, "正在生成二维码...", -1))
                                ]))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: wechatQrCode.value,
                                  alt: "QR Code",
                                  class: "qr-code-image"
                                }, null, 8, _hoisted_20))
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "scan-text" }, "扫码支付", -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createTextVNode(" 特惠价: ¥" + _toDisplayString(price.value) + " ", 1),
                              _createElementVNode("del", _hoisted_23, "原价: ¥" + _toDisplayString(originalPrice.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              (!__props.isLoggedIn)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "login-tip",
                                    onClick: handleLoginClick
                                  }, " 登录后支付可享受累计折扣优惠 → "))
                                : (userDiscountInfo.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _cache[22] || (_cache[22] = _createTextVNode(" 🎉 ")),
                                      _createElementVNode("strong", null, _toDisplayString(generateDiscountText(userDiscountInfo.value)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "benefits-link",
                              onClick: handleBenefitsClick
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Ticket))
                                ]),
                                _: 1
                              }),
                              _cache[23] || (_cache[23] = _createElementVNode("span", null, "点击查看更多折扣信息", -1)),
                              _createVNode(_component_el_icon, { class: "benefits-link-arrow" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArrowRight))
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "payment-prompt" }, "如遇支付问题, 请联系客服微信", -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "payment-prompt" }, "付款成功前请不要关闭此窗口。", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "支付宝",
                      name: "alipay"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (isLoadingQrCode.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createVNode(_component_el_icon, { class: "loading-icon" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Loading))
                                    ]),
                                    _: 1
                                  }),
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "loading-text" }, "正在生成二维码...", -1))
                                ]))
                              : (alipayHtml.value)
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 1,
                                    srcdoc: alipayHtml.value,
                                    class: "qr-code-image",
                                    frameborder: "0"
                                  }, null, 8, _hoisted_29))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 2,
                                    src: alipayQrCode.value,
                                    alt: "QR Code",
                                    class: "qr-code-image"
                                  }, null, 8, _hoisted_30))
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "scan-text" }, "扫码支付", -1)),
                            _createElementVNode("div", _hoisted_32, [
                              _createTextVNode(" 特惠价: ¥" + _toDisplayString(price.value) + " ", 1),
                              _createElementVNode("del", _hoisted_33, "原价: ¥" + _toDisplayString(originalPrice.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              (!__props.isLoggedIn)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "login-tip",
                                    onClick: handleLoginClick
                                  }, " 登录后支付可享受累计折扣优惠 → "))
                                : (userDiscountInfo.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _cache[28] || (_cache[28] = _createTextVNode(" 🎉 ")),
                                      _createElementVNode("strong", null, _toDisplayString(generateDiscountText(userDiscountInfo.value)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "benefits-link",
                              onClick: handleBenefitsClick
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Ticket))
                                ]),
                                _: 1
                              }),
                              _cache[29] || (_cache[29] = _createElementVNode("span", null, "点击查看更多折扣信息", -1)),
                              _createVNode(_component_el_icon, { class: "benefits-link-arrow" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ArrowRight))
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "payment-prompt" }, "如遇支付问题, 请联系客服微信", -1)),
                            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "payment-prompt" }, "付款成功前请不要关闭此窗口。", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "激活码",
                      name: "activationCode"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_el_input, {
                              modelValue: activationCode.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activationCode).value = $event)),
                              placeholder: "请输入激活码",
                              class: "activation-input",
                              loading: isLoadingActivation.value,
                              onKeyup: _withKeys(handleActivationCodePayment, ["enter"])
                            }, null, 8, ["modelValue", "loading"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              class: "activation-btn",
                              loading: isLoadingActivation.value,
                              onClick: handleActivationCodePayment
                            }, {
                              default: _withCtx(() => _cache[33] || (_cache[33] = [
                                _createTextVNode(" 确认使用 ")
                              ])),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "activation-tips" }, [
                            _createElementVNode("div", { class: "tip-item" }, "请确认激活码的有效性和适用范围"),
                            _createElementVNode("div", { class: "tip-item" }, "使用激活码后订单将立即完成支付")
                          ], -1))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(View))
                ]),
                _: 1
              }),
              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "ml-1" }, "论文预览:", -1))
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "preview-page-meta" }, [
                  _createElementVNode("span", null, "封面"),
                  _createElementVNode("span", null, "01")
                ], -1)),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(CoverPage, {
                      title: __props.order.title
                    }, null, 8, ["title"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "preview-page-meta" }, [
                  _createElementVNode("span", null, "目录"),
                  _createElementVNode("span", null, "02")
                ], -1)),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(TableOfContentsPage, {
                      catalogs: __props.order.catalogs
                    }, null, 8, ["catalogs"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "width"]),
    _createVNode(_component_el_dialog, {
      "model-value": showMobileActivationDialog.value,
      title: "激活码支付",
      width: isMobile.value ? '90%' : '400px',
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (showMobileActivationDialog.value = $event)),
      "show-close": true,
      center: "",
      class: "mobile-activation-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_el_input, {
              modelValue: mobileActivationCode.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mobileActivationCode).value = $event)),
              placeholder: "请输入激活码",
              size: "large",
              class: "mobile-activation-input",
              loading: isLoadingActivation.value,
              onKeyup: _withKeys(handleMobileActivationPayment, ["enter"])
            }, null, 8, ["modelValue", "loading"])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_el_button, {
              size: "large",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (showMobileActivationDialog.value = false))
            }, {
              default: _withCtx(() => _cache[38] || (_cache[38] = [
                _createTextVNode(" 取消 ")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "large",
              loading: isLoadingActivation.value,
              onClick: handleMobileActivationPayment
            }, {
              default: _withCtx(() => _cache[39] || (_cache[39] = [
                _createTextVNode(" 确认使用 ")
              ])),
              _: 1
            }, 8, ["loading"])
          ]),
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "mobile-activation-tips" }, [
            _createElementVNode("div", { class: "tip-item" }, "• 请确认激活码的有效性和适用范围"),
            _createElementVNode("div", { class: "tip-item" }, "• 使用激活码后订单将立即完成支付"),
            _createElementVNode("div", { class: "tip-item" }, "• 激活码一经使用无法退回")
          ], -1))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "width"])
  ], 64))
}
}

})